'use client'

// Force dynamic rendering for this page
export const dynamic = 'force-dynamic'

import Link from 'next/link'
import { ArrowLeft } from 'lucide-react'
import { useEffect, useState } from 'react'

export default function NotFound() {
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    // VAPT #15: the access token is an HttpOnly cookie (not JS-readable), so
    // infer sign-in state from the `airbills_signed_in` marker set on a
    // successful /me hydrate and cleared on logout.
    const checkAuth = () => {
      try {
        setIsLoggedIn(!!localStorage.getItem('airbills_signed_in'))
      } catch (error) {
        setIsLoggedIn(false)
      }
    }
    checkAuth()
  }, [])

  const returnHref = isLoggedIn ? '/dashboard' : '/sign-in'
  const returnText = isLoggedIn ? 'Return to Dashboard' : 'Return to Sign in'

  return (
    <div className="flex items-center justify-center min-h-screen bg-background p-4">
      <div className="w-full max-w-3xl border shadow-lg rounded-lg p-8 text-center">
        <h1 className="text-3xl font-bold mb-4">
          Page Not Found
        </h1>
        <p className="text-lg mb-6">
          The page you're looking for couldn't be found.
        </p>
        <Link 
          href={returnHref}
          className="inline-flex items-center gap-2 px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90"
        >
          <ArrowLeft className="h-4 w-4" />
          {returnText}
        </Link>
      </div>
    </div>
  )
}